import React, { useState } from 'react';
import { Button } from '@chakra-ui/react';
import { SharedIconInfo } from '../icons';

// Define the type for the props
interface BusinessCalculatorProps {
  toggleIncomeCalculator: (value: string) => void;
  toggleLastStep: () => void;
}

const SharedIncomeCalculatorBusiness: React.FC<BusinessCalculatorProps> = ({ toggleLastStep }) => {
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<number | undefined>();

  // Create an array for the last 4 years and an extra option for "Earlier than"
  const years = Array.from({ length: 5 }, (_, index) => currentYear - index);

  return (
    <div>
      <div className={`mb-4`}>Vanaf wanneer werk je zelfstandig?</div>
      <div>
        {years.map((year, index) => (
          <Button
            colorScheme={selectedYear === year ? 'blue' : 'gray'}
            key={year}
            m={4}
            onClick={() => setSelectedYear(year)}>
            {index === 4 ? `Eerder dan ${currentYear - 3}` : year}
          </Button>
        ))}
      </div>

      {selectedYear && (
        <>
          <div className={`mt-8  bg-gray-100 p-8 rounded`}>
            <div>
              <SharedIconInfo boxSize={8}></SharedIconInfo> Toelichting
            </div>
            <div className={`mt-4`}>
              {selectedYear === currentYear
                ? 'Je dient minimaal 12 maanden actief te zijn als ondernemer. Uitgangspunt hierbij is de inschrijving bij de Kamer van Koophandel.'
                : 'Zorg dat je je aangiften inkomstenbelasting en de jaarcijfers van de afgelopen drie jaar bij de hand hebt.'}
            </div>
          </div>
          <Button colorScheme={`orange`} onClick={toggleLastStep} mt={4}>
            Volgende
          </Button>
        </>
      )}
    </div>
  );
};
export default SharedIncomeCalculatorBusiness;
